import DockMonitor from './DockMonitor';
export default DockMonitor;
